import type { MenuProps } from 'antd';
import {
  HomeOutlined,
  TeamOutlined,
  DatabaseOutlined,
  GithubOutlined,
  LogoutOutlined,
  TableOutlined,
  PartitionOutlined,
  BarChartOutlined,
  WalletOutlined,
} from '@ant-design/icons';
import { clearAllTenantSelectionSessions, type AuthSession } from '@modeling/account';
import type { AdminScope } from '../types/adminScope';

export function createMenuItems(session: AuthSession, scope: AdminScope | null): MenuProps['items'] {
  const items: MenuProps['items'] = [{ key: '/', icon: <HomeOutlined />, label: '首页' }];

  if (scope?.canAccessDcAdmin) {
    items.push({ key: '/tenants', icon: <TeamOutlined />, label: '租户管理' });
  }

  if (scope?.isPlatformAdmin) {
    items.push({ key: '/schema-profiles', icon: <DatabaseOutlined />, label: 'Schema Profile' });
    items.push({ key: '/workflow-profiles', icon: <PartitionOutlined />, label: '工作流定义' });
    items.push({ key: '/schema-indexes', icon: <TableOutlined />, label: '索引管理' });
    items.push({ key: '/git-credentials', icon: <GithubOutlined />, label: 'Git 凭据' });
    items.push({ key: '/ai-usage', icon: <BarChartOutlined />, label: 'AI 用量' });
    items.push({ key: '/credits', icon: <WalletOutlined />, label: '积分' });
  }

  items.push(
    { type: 'divider' },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: () => {
        clearAllTenantSelectionSessions();
        void session.logout({ redirectUri: `${window.location.origin}/login` });
      },
    },
  );

  return items;
}

export const routeTitles: Record<string, string> = {
  '/': '首页',
  '/tenants': '租户管理',
  '/tenants/:tenantId/spaces': '空间管理',
  '/schema-profiles': 'Schema Profile',
  '/workflow-profiles': '工作流定义',
  '/schema-indexes': '索引管理',
  '/git-credentials': 'Git 凭据',
  '/ai-usage': 'AI 用量',
  '/credits': '积分',
};
